import { TrailerList } from '@src/trailer/domain/TrailerList';
import { TrailerClient } from '@src/trailer/service/TrailerClient';
import { useQuery } from '@tanstack/react-query';

export const useTrailers = (clientId: string) => {
  const { data: trailers = new TrailerList([]), isLoading } =
    useQuery<TrailerList>({
      queryKey: ['trailers.list', clientId],
      queryFn: () => TrailerClient.list(clientId),
    });
  return {
    trailers,
    isLoading,
  };
};
